import { Navigate as NavigateRR } from 'react-router';
import type { ComponentProps, FC } from 'react';

import { stripHash } from './hash/hashUtils';

type Props = {
    to: string;
    state?: ComponentProps<typeof NavigateRR>['state'];
};

/**
 * A component for declarative navigation in the application.
 * Use this component when you want to navigate to a new route as a side effect.
 *
 * @param {Props} props - The component props
 * @returns {React.ReactNode} A component that triggers navigation when rendered
 *
 * @example
 * ```tsx
 * import { Navigate } from '@luna/router';
 *
 * // Basic usage: Redirect to home page
 * const RedirectToHome = () => <Navigate to="/home" />;
 *
 * // Conditional navigation
 * const ConditionalRedirect = ({ isLoggedIn }) => (
 *   isLoggedIn ? <Dashboard /> : <Navigate to="/login" />
 * );
 * ```
 */
export const Navigate: FC<Props> = ({ to, state }) => {
    return <NavigateRR replace to={stripHash(to)} state={state} />;
};
